export default {
  setMarkersRequestStarted(state) {
    state.markersLoading = true
    state.markersLoaded = false
  },
  setMarkersRequestSuccess(state, { subjectTypes, markers, mailingGroups }) {
    state.markersLoading = false
    state.markersLoaded = false
    state.subjectTypes = subjectTypes
    state.markers = markers
    state.mailingGroups = mailingGroups
  },
  setMarkersRequestError(state) {
    state.markersLoading = false
    state.markersLoaded = false
    state.loadingError = true
  },
}
